export const convertByRates = (
  amount: number,
  fromCurrency: string | null | undefined,
  toCurrency: string,
  rates: Record<string, number>
): number | null => {
  const from = (fromCurrency || '').toUpperCase();
  const to = toCurrency.toUpperCase();
  if (!from || !to) return null;
  if (from === to) return amount;
  const fromRate = rates[from];
  const toRate = rates[to];
  if (!fromRate || !toRate) return null;
  return Math.round((amount / fromRate) * toRate);
};
